import { useBusEmitterListener } from "../bridge";

const diagramPlayersChangedEvent = Symbol("bridge:diagramPlayersChanged");

export const {
  emitter: diagramPlayersChanged,
  listener: onDiagramPlayersChanged,
} = useBusEmitterListener(diagramPlayersChangedEvent);

const diagramPlayerFrameChangedEvent = Symbol("bridge:diagramPlayerFrameChanged");
const {
  emitter: diagramPlayerFrameChangedFn,
  listener: onDiagramPlayerFrameChangedFn,
} = useBusEmitterListener<{ frameId: string; previousEnabled: boolean; nextEnabled: boolean; resetEnabled: boolean }>(diagramPlayerFrameChangedEvent);

export function diagramPlayerFrameChanged(frameId: string, previousEnabled: boolean, nextEnabled: boolean, resetEnabled: boolean) {
  diagramPlayerFrameChangedFn({ frameId, previousEnabled, nextEnabled, resetEnabled });
}

export const onDiagramPlayerFrameChanged = onDiagramPlayerFrameChangedFn;
